// Components
import rootStyles from '../../pages/puppy/[id].module.scss'
import styles from './AboutBreed.module.scss'
import Image from 'next/legacy/image'
import {
  trainingConverter,
  energyConverter,
  sheddingConverter
} from '../../utils/converter'
import Title from '../Title'
import TextBody from '../TextBody/TextBody'
import Link from 'next/link'

const Facts = ({ breed }) => {
  const {
    lifeSpanMax,
    lifeSpanMin,
    easyToTrain,
    energyLevel,
    amountOfShedding
  } = breed

  const facts = [
    {
      img: '/facts/shedding.svg',
      title: 'Shedding',
      value: `${sheddingConverter(amountOfShedding)}`
    },
    {
      img: '/facts/training.svg',
      title: 'Trainability',
      value: `${trainingConverter(easyToTrain)}`
    },
    {
      img: '/facts/life-span.svg',
      title: 'Life span',
      value: `${lifeSpanMin} to ${lifeSpanMax} years`
    },
    {
      img: '/facts/energy.svg',
      title: 'Energy',
      value: `${energyConverter(energyLevel)}`
    }
  ]

  return (
    <div className={styles.facts}>
      <div className={styles.factsHeader}>
        <h4>Breed fast facts</h4>
      </div>

      <div className={styles.info}>
        {facts.map((fact, i) => {
          return (
            <div key={i} className={styles.fact}>
              <img src={fact.img} alt='' />
              <h5>{fact.title}</h5>
              <p>{fact.value}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default function AboutBreed ({ breed, breedDetails }) {
  const image = breed?.profilePicture?.medium

  return (
    <div className={rootStyles.section}>
      <Title variant='h2'>About {breed?.name}</Title>

      <div className={styles.content}>
        {image && (
          <div className={styles.imageContainer}>
            <Image
              width={201}
              height={201}
              src={process.env.NEXT_PUBLIC_MEDIA_BUCKET + image}
              alt={breed?.name}
            />
          </div>
        )}

        <div className={styles.factsContainer}>
          <Facts breed={breedDetails} />
        </div>
      </div>

      {breed?.temperament && (
        <div className={styles.temperament}>
          <h4>Temperament</h4>

          <p>{breed.temperament}</p>
        </div>
      )}

      {breed?.description && <TextBody>{breed?.description}</TextBody>}

      <Link
        className={styles.otherBreed}
        href={`${process.env.NEXT_PUBLIC_ROOT_URL}/puppies-for-sale/${breed.slug}`}
      >
        <TextBody weight='bold' className={styles.underline}>
          Explore other {breed?.name} puppies
        </TextBody>

        <div className={styles.arrowRight} />
      </Link>
    </div>
  )
}
